import React from 'react';
import "./Nav.scss";
import useGlobalStyles from '../../globalStyles';
import clsx from 'clsx';
import UserAvatar from '../User/UserAvatar';
import { getNameID } from '../../auth';
import { SelectInput } from '../Helpers/Inputs';
import { getAvailableEnvironments } from '../Quoter/QuoterManagement/constants';

export default function Nav({ expanded, isSignWithoutAuth, environment, onEnvironmentChange }) {
  const globalClasses = useGlobalStyles();

  const userName = getNameID();

  return (
    <div id="advisor-nav" className={clsx(globalClasses.flexDisplay, globalClasses.justifyContentBetween, globalClasses.alignItemsCenter, 'sticky-top', isSignWithoutAuth && 'ms-0', (expanded) ? "sidebar-open" : "sidebar-close")}>
      <img id="partner-logo" alt="partner-logo" src="/logos/covr-logo.svg" />
      {!isSignWithoutAuth && <div className={clsx(globalClasses.flexDisplay, globalClasses.alignItemsCenter)}>
        <div className='environment-select m-3'>
          <SelectInput
            label='Environment'
            selectOptions={getAvailableEnvironments()}
            value={environment}
            onChange={(e) => onEnvironmentChange(e.target.value)}
            hideEmptyOption={true}
            variant="outlined"
            size="large"
          />
        </div>
        <UserAvatar name={userName} />
      </div>}
    </div>
  );
}
